import styled from "styled-components";

export const Inner = styled.div`
  display: flex;

  & input {
    text-align: center;
  }
`;
